"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Article", {
  enumerable: true,
  get: function get() {
    return _article.Article;
  }
});
Object.defineProperty(exports, "Board", {
  enumerable: true,
  get: function get() {
    return _board.Board;
  }
});
Object.defineProperty(exports, "Mail", {
  enumerable: true,
  get: function get() {
    return _mail.Mail;
  }
});

var _article = require("./article");

var _board = require("./board");

var _mail = require("./mail");